import Image from "next/image";
import React from "react";
import DefaultCurrencyFormat from "../calendar/DefaultCurrencyFormat";

const PriceItem = ({ price, days }) => {
  return (
    <div
      className={`group flex items-center justify-between p-5 bg-[#757C7F] transition-all ease-in-out group duration-200 hover:bg-themeSecondColor bg-opacity-5 rounded-md relative`}
    >
      <div className="flex flex-col">
        <span
          className={`text-[#757C7F] group-hover:text-white sm:text-base text-sm font-bold leading-5`}
        >
          {price?.title}
        </span>
        <div className="flex items-center gap-2 ">
          <span className="text-xs opacity-60 group-hover:opacity-100 leading-5 group-hover:text-white">
            Minimum Kiralama : {price.gece} Gece
          </span>
          {Number(price.temizlikgece) > 0 && (
            <div className="group/info">
              <Image
                src="/icons/info.svg"
                alt="info button"
                width={16}
                height={16}
                className="group-hover:filter group-hover:invert group-hover:brightness-0"
              />
              {price.info && (
                <>
                  <div className="group-hover/info:inline-flex hidden absolute bottom-3/4 left-1/2 w-64 -translate-x-1/2 -translate-y-0 bg-white border border-lightWhite-1200 rounded-md py-2.5 px-4 shadow-price z-50">
                    <p className="font-work font-medium text-xs text-[#7D879A] leading-5">
                      {price.info}
                    </p>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col items-center">
        <span className="text-sm font-bold leading-4 sm:text-base text-themeBlack group-hover:text-white">
          {/* {price?.isDiscounted ? (
            <span className="line-through text-red-600 mr-2 text-sm">
              <DefaultCurrencyFormat
                value={
                  days === "night" ? price?.dailyPriceOld : price?.fiyatOld
                }
                Symbol={price?.Symbol}
              />
            </span>
          ) : (
            ""
          )} */}
          <DefaultCurrencyFormat
            value={
              days === "night"
                ? price?.dailyPriceOld || price?.dailyPrice
                : price?.fiyatOld || price?.fiyat
            }
            Symbol={price?.Symbol}
          />
          <span className="text-[#757C7F] group-hover:text-white">
            {" "}
            / {days === "night" ? "Gecelik" : "Haftalık"}
          </span>
        </span>
        {price.discountRate && (
          <span className="text-xs text-right group-hover:text-white">
            <span className="opacity-60 group-hover:opacity-100">
              {price.title} arasında{" "}
            </span>
            <strong>%{price.discountRate} indirimli</strong>
          </span>
        )}
      </div>
    </div>
  );
};

export default PriceItem;
